<template>
  <el-dialog
    title="温馨提示"
    customClass="customWidth"
    :visible.sync="visible"
    @close="closeDialog"
  >
    <div class="pop-centers-list">
      <div class="code">
        <!-- <img :src="wechatImg" alt /> -->
        <p>此素材网暂时不支持自动下载</p>
        <p>请联系客服</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["dVisible"],
  watch: {
    dVisible: {
      handler(val) {
        this.visible = val;
      },
      deep: true,
    },
  },
  data() {
    return {
      visible: false,
      wechatImg: require("@/assets/images/code.png"),
    };
  },
  methods: {
    linkOverseas(row) {
      window.open(row.enUrl);
    },
    linkDomestic(row) {
      window.open(row.zhUrl);
    },
    closeDialog() {
      this.$emit("closeDialogs");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.customWidth {
  width: 460px !important;
  min-width: 400px !important;
}
.pop-centers-list {
  text-align: center;
  width: 410px;
  z-index: 22;
  .code {
    padding: 20px 0 10px;
    text-align: center;
    img {
      height: 180px;
      width: 180px;
    }
    p {
      margin-top: 6px;
      font-size: 18px;
      color: #666;
    }
  }
}
</style>
